import { useQueryClient, useQueryDetails } from '@gogame/query';

import { loadConversionPage } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/conversion-pages';

import { conversionPagesGrids, conversionPagesModel } from './queryKeyFactory';

export const useLoadConversionPage = ({ id }) => {
  const queryClient = useQueryClient();
  return useQueryDetails(
    conversionPagesModel(id),
    () => loadConversionPage({ id }),
    {
      initialData: () => {
        const { tags, name } =
          queryClient
            .getQueryData(conversionPagesGrids(), {
              exact: false,
              active: true,
            })
            ?.rows?.find((d) => d.id === id) || {};

        return { id, name, tagIds: tags?.map(({ id }) => id) };
      },
    }
  );
};
